import { TableProps } from 'antd/es/table';

import { Status } from '@Components/Base';

export const mapColumns: TableProps['columns'] = [
  {
    title: 'REQUEST NO.',
    dataIndex: 'requestNo',
    key: 'requestId',
    sorter: true,
    ellipsis: true,
  },
  {
    title: 'PURPOSE',
    dataIndex: 'leaveType',
    key: 'leaveTypeID',
    sorter: true,
    ellipsis: true,
  },
  {
    title: 'REMARKS',
    dataIndex: 'remarks',
    key: 'remarks',
    sorter: true,
    ellipsis: true,
  },
  {
    title: 'REQUIRED LANGUAGE',
    dataIndex: 'destination',
    key: 'destination',
    sorter: true,
    ellipsis: true,
  },
  {
    title: 'REQUIRED BY',
    dataIndex: 'startDate',
    key: 'startDate',
    sorter: true,
    ellipsis: true,
  },
  {
    title: 'EMP NAME',
    dataIndex: 'empName',
    key: 'empName',
    sorter: true,
    ellipsis: true,
  },
  {
    title: 'APPROVER NAME',
    dataIndex: 'approverName',
    key: 'approverName',
    sorter: true,
    ellipsis: true,
  },
  {
    title: 'STATUS',
    dataIndex: 'status',
    key: 'reqStatusId',
    sorter: true,
    render: (text) => <Status text={text} />,
  },
];
